module.exports = __webpack_public_path__ + "static/media/new.9ca3363c.gif";